import { motion, useReducedMotion } from "framer-motion";

// Standard reveal: fade + translateY 24px · 600ms · cubic-bezier(0.16,1,0.3,1) · stagger 60ms
export const EASE_OUT = [0.16, 1, 0.3, 1];
export const REVEAL_DURATION = 0.6;
export const REVEAL_STAGGER = 0.06;

const VIEWPORT = { once: true, amount: 0.15, margin: "0px 0px -8% 0px" };

export const revealItemVariants = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: REVEAL_DURATION, ease: EASE_OUT } },
};

function pick(as) {
  return motion[as] || motion.div;
}

export function Reveal({ children, className = "", delay = 0, as = "div", amount, once = true, ...rest }) {
  const reduce = useReducedMotion();
  const Comp = pick(as);
  const motionProps = reduce
    ? {}
    : {
        initial: "hidden",
        whileInView: "show",
        viewport: { ...VIEWPORT, once, amount: amount ?? VIEWPORT.amount },
        variants: {
          hidden: { opacity: 0, y: 24 },
          show: { opacity: 1, y: 0, transition: { duration: REVEAL_DURATION, ease: EASE_OUT, delay } },
        },
      };
  return (
    <Comp className={className} {...motionProps} {...rest}>
      {children}
    </Comp>
  );
}

export function RevealGroup({
  children,
  className = "",
  as = "div",
  stagger = REVEAL_STAGGER,
  delay = 0,
  amount,
  once = true,
  ...rest
}) {
  const reduce = useReducedMotion();
  const Comp = pick(as);
  const motionProps = reduce
    ? {}
    : {
        initial: "hidden",
        whileInView: "show",
        viewport: { ...VIEWPORT, once, amount: amount ?? VIEWPORT.amount },
        variants: {
          hidden: {},
          show: { transition: { staggerChildren: stagger, delayChildren: delay } },
        },
      };
  return (
    <Comp className={className} {...motionProps} {...rest}>
      {children}
    </Comp>
  );
}

export function RevealItem({ children, className = "", as = "div", ...rest }) {
  const Comp = pick(as);
  return (
    <Comp className={className} variants={revealItemVariants} {...rest}>
      {children}
    </Comp>
  );
}
